import React from "react";
import DOMPurify from "dompurify";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

type TruncatedQuillContentProps = {
  content: string;
  maxLines?: number;
};

const TruncatedLimitContent: React.FC<TruncatedQuillContentProps> = ({ 
  content, 
  maxLines = 3 
}) => {
  // Sanitize HTML content
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <Box
      sx={{
        position: 'relative',
        maxHeight: `${maxLines * 1.5}em`, // Adjust line height as needed
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
      }}
    >
      <div
        className="ql-editor"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        style={{
          padding: 0,
          margin: 0,
          lineHeight: 1.5,
        }}
      />
      {/* Optional: Add a gradient overlay for fade effect */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50px',
          background: 'linear-gradient(transparent, white)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
};

export default TruncatedLimitContent;